import React, { useState } from 'react'
import Image from 'next/image'
import { AiOutlinePlus, AiOutlineMinus } from 'react-icons/ai';

const BlogCard = ({ question, answer }) => {

  const [blogVisible, setBlogVisible] = useState(true)

  return (
    <div className="flex mb-[30px] pb-[30px] gap-[20px] border-b border-b-gray-300">
      <div onClick={() => blogVisible ? setBlogVisible(false) : setBlogVisible(true)} className="pt-[5px] text-[20px] md:text-[35px] w-fit cursor-pointer">
        {
          blogVisible ?
          <AiOutlineMinus />
          :
          <AiOutlinePlus />
        }
      </div>
      <div className="">
        <div className="question text-[25px] md:text-[30px] mb-[20px] font-medium">{question}</div>
        {
          blogVisible ?
            <div className="answer text-[16px] md:text-[18px] font-light text-gray-700">
              {answer}
            </div>
            :
            ""

        }
      </div>
    </div>
  )
}

export default BlogCard
